<template>
    <div :class="classes" ref="cell">
        <template v-if="renderType === 'index'"><span>{{ column.indexMethod ? column.indexMethod(row) : (naturalIndex + 1) }}</span></template>
        <template v-else-if="renderType === 'selection'">
            <template v-if="column.editCfg&&column.editCfg.type=='radio'">
                <Radio :value="checked" @click.native.stop="handleClick" @on-change="toggleSelect('radio')" :disabled="disabled"></Radio>
            </template>
            <template v-else>
                <Checkbox :value="checked" @click.native.stop="handleClick" @on-change="toggleSelect('checkbox')" :disabled="disabled"></Checkbox>
            </template>
        </template>
        <template v-else-if="renderType === 'html'"><span v-html="row[column.key]"></span></template>
        <template v-else-if="renderType === 'normal'">
            <template v-if="column.tooltip">
                <Tooltip transfer :content="row['__'+column.key]||row[column.key]" :disabled="!showTooltip" :max-width="300" class="ivu-table-cell-tooltip">
                    <p ref="content" @mouseenter="handleTooltipIn" @mouseleave="handleTooltipOut" class="ivu-table-cell-tooltip-content">{{ row['__'+column.key]||row[column.key] }}</p>
                </Tooltip>
            </template>
            <span v-else>{{row['__'+column.key]||row[column.key]}}</span>
        </template>
        
        <template v-else-if="renderType === 'input'">
            <div @click="showPopper">
                <plug-input 
                    :col="column" 
                    :row="row"
                    :content="row[column.key]"
                    :editCfg="column.editCfg||{}" 
                    :visible="showEdit"
                    :always="column.always"
                    :editAlways="editAlways"
                    :validErr="validErr"
                    :validMsg="validMsg"
                    @onChange="onChange"
                    @onChangeShowEdit="onChangeShowEdit"
                    @setColEditDisabled="setColEditDisabled"></plug-input>
            </div>
        </template>
        <template v-else-if="renderType === 'btns'" >
            <div @click="showPopper">
                <plug-btn
                    :col="column"
                    :row="row"
                    :rowOriginal="rowOriginal"
                    :editCfg="column.editCfg||{}" 
                    :visible="showEdit"
                    @onChangeShowEdit="onChangeShowEdit"></plug-btn>
            </div>
        </template>
        <template v-else-if="renderType === 'textarea'">
            <div @click="showPopper">
                <plug-textarea 
                    :col="column"
                    :row="row"
                    :content="row[column.key]" 
                    :editCfg="column.editCfg||{}" 
                    :visible="showEdit"
                    :always="column.always"
                    :editAlways="editAlways"
                    :validErr="validErr"
                    :validMsg="validMsg"
                    @onChange="onChange"
                    @onChangeShowEdit="onChangeShowEdit"
                    @setColEditDisabled="setColEditDisabled"></plug-textarea>
            </div>
        </template>
        <template v-else-if="renderType === 'dropdown'" >
            <div @click="showPopper">
                <plug-dropdown
                    :col="column"
                    :row="row"
                    :content="row[column.key]" 
                    :editCfg="column.editCfg||{}" 
                    :visible="showEdit"
                    :always="column.always"
                    :editAlways="editAlways"
                    :validErr="validErr"
                    @on-query-change="onQueryChange"
                    :validMsg="validMsg"
                    @onChange="onChange"
                    @onChangeShowEdit="onChangeShowEdit"
                    @setColEditDisabled="setColEditDisabled"></plug-dropdown>
            </div>
        </template>
        <template v-else-if="renderType === 'date'" >
            <div @click="showPopper">
                <plug-date
                    :col="column"
                    :row="row"
                    :content="row[column.key]" 
                    :editCfg="column.editCfg||{}" 
                    :visible="showEdit"
                    :always="column.always"
                    :editAlways="editAlways"
                    :validErr="validErr"
                    :validMsg="validMsg"
                    @onChange="onChange"
                    @onChangeShowEdit="onChangeShowEdit"
                    @setColEditDisabled="setColEditDisabled"></plug-date>
            </div>
        </template>
        <template v-else-if="renderType === 'user'" >
            <div @click="showPopper">
                <plug-user
                    :col="column"
                    :row="row"
                    :content="row[column.key]" 
                    :editCfg="column.editCfg||{}" 
                    :visible="showEdit"
                    :always="column.always"
                    :editAlways="editAlways"
                    :validErr="validErr"
                    :validMsg="validMsg"
                    @onChange="onChange"
                    @onChangeShowEdit="onChangeShowEdit"
                    @setColEditDisabled="setColEditDisabled"></plug-user>
            </div>
        </template>
        <template v-else-if="renderType === 'checkbox'" >
            <div @click="showPopper">
                <plug-checkbox
                    :row="row"
                    :col="column"
                    :content="row[column.key]" 
                    :editCfg="column.editCfg||{}" 
                    :visible="showEdit"
                    :always="column.always"
                    :editAlways="editAlways"
                    :validErr="validErr"
                    :validMsg="validMsg"
                    @onChange="onChange"
                    @onChangeShowEdit="onChangeShowEdit"
                    @setColEditDisabled="setColEditDisabled"></plug-checkbox>
            </div>
        </template>
        <template v-else-if="renderType === 'radio'" >
            <div @click="showPopper">
                <plug-radio
                    :row="row"
                    :col="column"
                    :content="row[column.key]" 
                    :editCfg="column.editCfg||{}" 
                    :visible="showEdit"
                    :always="column.always"
                    :editAlways="editAlways"
                    :validErr="validErr"
                    :validMsg="validMsg"
                    @onChange="onChange"
                    @onChangeShowEdit="onChangeShowEdit"
                    @setColEditDisabled="setColEditDisabled"></plug-radio>
            </div>
        </template>
        <template v-else-if="renderType === 'link'" >
            <div @click="showPopper">
                <plug-link
                    :col="column"
                    :row="row"
                    :rowOriginal="rowOriginal"
                    :content="row['__'+column.key]||row[column.key]" 
                    :editCfg="column.editCfg||{}" 
                    :visible="showEdit"
                    :always="column.always"
                    :editAlways="editAlways"
                    @onChangeShowEdit="onChangeShowEdit"
                    @setColEditDisabled="setColEditDisabled"></plug-link>
            </div>
        </template>
        <template v-else-if="renderType === 'number'" >
            <div @click="showPopper">
                <plug-number
                    :col="column"
                    :row="row"
                    :rowOriginal="rowOriginal"
                    :content="row[column.key]" 
                    :editCfg="column.editCfg||{}" 
                    :visible="showEdit"
                    :always="column.always"
                    :editAlways="editAlways"
                    :validErr="validErr"
                    :validMsg="validMsg"
                    @onChange="onChange"
                    @onChangeShowEdit="onChangeShowEdit"
                    @setColEditDisabled="setColEditDisabled"></plug-number>
            </div>
        </template>
        <template v-else-if="renderType === 'compoundEdit'">
            <div @click="showPopper">
                <compound-edit
                    :column="column" 
                    :row="row"
                    :content="row[column.key]"
                    :editCfg="column.editCfg||{}"
                    :visible="showEdit"
                    :always="column.always"
                    :editAlways="editAlways"
                    :validErr="validErr"
                    :validMsg="validMsg"
                    :onChange="onChange"
                    @onChangeShowEdit="onChangeShowEdit"
                    :setColEditDisabled="setColEditDisabled"></compound-edit>
            </div>
        </template>
        <template v-else-if="renderType === 'Tabletip'" >
            <template v-if="setTableData().toString()===''">
                <span>{{row[column.key]}}</span>
            </template>
            <template v-else>
                <Tabletip :columns="column.editCfg.columns" :tableData="setTableData()" :padding="column.editCfg.padding" :trigger="column.editCfg.trigger" theme="light">
                    <span >{{row[column.key]}}</span>
                </Tabletip>
            </template>
        </template>
        <template v-else-if="renderType === 'expand'">
            <span>{{row[column.key]}}</span>
            <div :class="expandCls" @click="toggleExpand" v-if="renderType === 'expand' && !row._disableExpand">
                <Icon icon="angle-right"></Icon>
            </div>
        </template>
        <Cell
            v-if="renderType === 'render'"
            :row="row"
            :column="column"
            :index="index"
            :render="column.render"></Cell>
    </div>
</template>
<script>
    import Cell from './expand';
    // import Icon from '../icon/icon.vue';
    // import Checkbox from '../checkbox/checkbox.vue';
    import Tooltip from '../tooltip/tooltip.vue';
    import plugBtn from './plug/btn.vue';
    import plugInput from './plug/input.vue';
    import plugTextarea from './plug/textarea.vue';
    import plugDropdown from './plug/dropdown.vue';
    import plugDate from './plug/date.vue';
    import plugUser from './plug/user.vue';
    import plugCheckbox from './plug/checkbox.vue';
    import plugRadio from './plug/radio.vue';
    import plugLink from './plug/link.vue';
    import plugNumber from './plug/number.vue';
    import Tabletip from '../tabletip/tabletip.vue';
    import validator from './validated/validator.js';
    import compoundEdit from './plug/compoundEdit.vue';
    export default {
        name: 'TableCell',
        // components: { Icon, Checkbox, Cell, Tooltip },
        components: { Cell ,Tooltip,plugBtn,plugInput,plugTextarea,plugDropdown,plugDate,plugUser,plugCheckbox,plugRadio,plugLink,plugNumber,Tabletip,compoundEdit},
        props: {
            prefixCls: String,
            row: Object,
            rowOriginal:Object,
            column: Object,
            naturalIndex: Number,    // index of rebuildData
            index: Number,           // _index of data
            checked: Boolean,
            disabled: Boolean,
            expanded: Boolean,
            fixed: {
                type: [Boolean, String],
                default: false
            },
            editAlways:{
                type: Boolean
            },
        },
        data () {
            return {
                renderType: '',
                uid: -1,
                context: this.$parent.$parent.$parent.currentContext,
                showTooltip: false,  // 鼠标滑过overflow文本时，再检查是否需要显示
                showCellEdit:false,
                showEdit:false,
                colEditDisabled:false,
                oldValue:this.row[this.column.key],
                validErr:false,
                validMsg:''
            };
        },
        computed: {
            classes () {
                return [
                    `${this.prefixCls}-cell`,
                    {
                        [`${this.prefixCls}-hidden`]: !this.fixed && this.column.fixed && (this.column.fixed === 'left' || this.column.fixed === 'right'),
                        [`${this.prefixCls}-cell-ellipsis`]: this.column.ellipsis || false,
                        [`${this.prefixCls}-cell-with-expand`]: this.renderType === 'expand',
                        [`${this.prefixCls}-cell-with-selection`]: this.renderType === 'selection',
                        [`${this.prefixCls}-cell-edit`]: this.showCellEdit === true
                    }
                ];
            },
            expandCls () {
                return [
                    'inline-block',
                    `${this.prefixCls}-cell-expand`,
                    {
                        [`${this.prefixCls}-cell-expand-expanded`]: this.expanded
                    }
                ];
            }
        },
        methods: {
            /**
             * @value 需要修改的值
             * @col 需要修改的列
             * @valueItem 修改的值的整个对象(如果有)
             */
            onChange(value,col,valueItem,isChange){
                let row=this.row
                if(row[col.key]!==value||isChange){
                    row._changeStatus=row._changeStatus=="-1"?"1":row._changeStatus
                    row[col.key]=value
                    this.oldValue=value
                }
                //调用列值改变后事件
                if(this.column.onAfterChange){this.column.onAfterChange(value,col,row,valueItem,this.rowOriginal)}
            },
            onChangeShowEdit(showEdit,value){
                let self=this,col=this.column
                //调用列编辑后事件
                if(col.onAfterEdit){col.onAfterEdit(col,this.row,this.rowOriginal)}
                this.validator(value)
                this.showEdit = showEdit;
            },
            onQueryChange(value){
                let self=this,col=this.column
                //调用列编辑后事件
                if(col.onQueryChange){col.onQueryChange(col,this.row,value)}
            },
            validator(value){
                let self=this,col=this.column
                if(col.rules){
                    var defer = self.$utils.deferred();
                    self.$utils.when(validator.validRules(col.rules,value)).always(function (result, name) {
                        let flage=false
                        if(result !== true){
                            flage=true
                            self.validMsg=result
                        }
                        self.validErr=flage
                        defer.resolve(flage);
                    })
                    return defer.promise();
                }
            },
            setColEditDisabled(colEditDisabled){
                this.colEditDisabled=colEditDisabled
            },
            showPopper(){
                let self=this,show=false,col=self.column,showEdit=col.showEdit;
                if(this.colEditDisabled){
                    return false
                }
                //编辑器显示前事件
                if(col.onBeforeShowEdit){
                    if(col.onBeforeShowEdit(col,this.row,this.rowOriginal)==false){
                        return false;
                    }
                }
                //如果存在列设置showEdit，则以showEdit为准
                if(showEdit){
                    if(showEdit==self.row._changeStatus){
                        show = true;
                    }else if(this.$utils.isObject(showEdit)){
                        show = true;
                        //如果传递的是对象
                        let keys=Object.keys(showEdit)
                        for(let i=0;i<keys.length;i++){
                            let key=keys[i]
                            if(self.row[key]!==showEdit[key]&&!!self.row[key]!==showEdit[key]){
                                show = false;
                                break;
                            }
                        }
                    }
                }
                //删除状态不显示编辑器
                else if(self.row._changeStatus!="0"){
                    show = true;
                }
                this.showEdit=show
            },
            setTableData(){
                let row=this.row
                return this.column.editCfg.setTableData(row)|| column.editCfg.tableData||[]
            },
            toggleSelect (type) {
                this.$parent.$parent.$parent.toggleSelect(this.index,type);
            },
            toggleExpand () {
                this.$parent.$parent.$parent.toggleExpand(this.index);
            },
            handleClick () {
                // 放置 Checkbox 冒泡
            },
            handleTooltipIn () {
                const $content = this.$refs.content;
                this.showTooltip = $content.scrollWidth > $content.offsetWidth;
            },
            handleTooltipOut () {
                this.showTooltip = false;
            }
        },
        created () {
            //添加必填标识样式
            if(this.column.rules&&this.column.rules.required){
                this.column.className="ivu-table-column-required"
            }
            if (this.column.type === 'index') {
                this.renderType = 'index';
            }else if(this.column.type === 'Tabletip'){
                this.renderType = 'Tabletip';
            }else if (this.column.type === 'selection') {
                this.renderType = 'selection';
            } else if (this.column.type === 'html') {
                this.renderType = 'html';
            } else if (this.column.type === 'expand') {
                this.renderType = 'expand';
            } else if (this.column.edit=="true") {
                this.renderType = 'input';
                this.showCellEdit = true
                if(this.column.type === 'textarea'){
                    this.renderType = 'textarea';
                }
                if(this.column.type === 'dropdown'){
                    this.renderType = 'dropdown';
                }
                if(this.column.type === 'date'){
                    this.renderType = 'date';
                }
                if(this.column.type === 'user'){
                    this.renderType = 'user';
                }
                if(this.column.type === 'btns'){
                    this.renderType = 'btns';
                }
                if(this.column.type === 'checkbox'){
                    this.renderType = 'checkbox';
                }
                if(this.column.type === 'radio'){
                    this.renderType = 'radio';
                }
                if(this.column.type === 'link'){
                    this.renderType = 'link';
                }
                if(this.column.type === 'number'){
                    this.renderType = 'number';
                }
                if(this.column.type === 'compoundEdit'){
                    this.renderType = 'compoundEdit';
                }
            }else if (this.column.render) {
                this.renderType = 'render';
            } else {
                this.renderType = 'normal';
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/common/table/cell.vue